module.exports = __webpack_public_path__ + "static/media/math-card-bg.40cb2c4b.png";